const rates = {
  createRateBtn: 'הוסף',
  showBreakdownBtn: 'הצג פירוט',
  total: 'Total: ',

  table: {
    headers: {
      name: 'שם',
      code: 'קוד',
      supplierName: 'ספק',
      isActive: 'סטטוס',
      isAvailable: 'זמין',
      biDir: 'דו-כיווני',
    },
    filters: {
      code: 'קוד',
      supplier: 'ספק',
      profile: 'פרופיל',
      attributes: 'מאפיינים',
      service: 'שירות',
    },
    cells: {
      isActive: {
        true: 'פעיל',
        false: 'לא פעיל',
      },
      isAvailable: {
        true: 'כן',
        false: 'לא',
      },
    },
    biDirOptions: {
      way2: 'דו-כיווני',
      way1: 'חד-כיווני',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
  },

  deleteModal: {
    header: 'מחק תעריפים',
    body: 'אתה עומד למחוק {{num}} תעריפים.',
  },

  rateTypeOptions: {
    Base: 'בסיס',
    Addition: 'תוספת',
    Percent: 'אחוז',
    Total: 'סה"כ',
  },

  additions: {
    value: 'ערך',
    valueType: 'סוג ערך',
    name: 'שם',
    hour1: 'שעת התחלה',
    hour2: 'שעת סיום',
    date1: 'תאריך התחלה',
    date2: 'תאריך סיום',
    cancel: 'בטל',
    addAddition: 'הוסף תוספת',
    priority: 'עדיפות',
    weekDays: 'ימי השבוע',
    newAddition: 'תוספת חדשה',
    price: 'מחיר',
    total: 'סה"כ',
    percent: 'אחוז',
    columnExist: 'הכותרת כבר קיימת',
  },

  toast: {
    error: {
      badResponse: '[מיקומים] תגובת שרת שגויה',
    },
  },

  create: {
    successToast: {
      message: 'הצלחה! התעריף נוצר',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור תעריף',
    },
  },

  edit: {
    successToast: {
      message: 'הצלחה! התעריף עודכן',
    },

    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן תעריף',
    },

    modalError: {
      header: 'שגיאה.',
      body: 'לא ניתן לעדכן תעריף.',
    },
  },

  delete: {
    successToast: {
      message: '[תעריפים] נמחקו בהצלחה',
    },

    errorToast: {
      message: '[תעריפים] תגובת שרת שגויה',
    },
  },

  forms: {
    header: {
      createRate: {
        title: 'הוסף',
      },

      updateRate: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'פרטי תעריף',
        fields: {
          units: {
            name: 'Sites',
          },
          from: {
            name: 'From',
          },
          to: {
            name: 'To',
          },
          supplierId: {
            name: 'ספק',
          },
          servicesIds: {
            name: 'שירות',
          },
          profilesIds: {
            name: 'פרופיל',
          },
          attributesIds: {
            name: 'תכונה',
          },
          biDirectional: {
            name: 'דו-כיווני',
          },
          group: {
            name: 'Rate Group',
          },
          name: {
            name: 'שם',
          },
        },
      },
    },
    type: {
      header: 'Rate Type',
      fields: {
        fromAreasIds: 'מאזור',
        toAreasIds: 'לאזור',
        biDirectional: 'דו-כיווני',
        basePrice: 'מחיר בסיסי',
        durationFactors: {
          baseDuration: 'משך בסיסי',
          pricePerAdditional: {
            value: 'לכל דקה נוספת',
            type: {
              fixed: 'קבוע',
              percentage: 'אחוזים (מהבסיס)',
            },
          },
        },
        distanceFactors: {
          baseDistance: 'מרחק בסיסי',
          pricePerAdditional: {
            value: 'לכל ק"מ/מייל נוסף',
            type: {
              fixed: 'קבוע',
              percentage: 'אחוזים (מהבסיס)',
            },
          },
        },
      },
      addBtn: 'הוסף',
    },
    availability: {
      header: 'זמינות תעריף',
      fields: {
        from: 'זמין מ',
        to: 'זמין עד',
        fromTime: 'זמן התחלה',
        toTime: 'זמן סיום',
        weekDays: 'ימי חול',
      },
      addBtn: 'הוסף זמינות',
    },

    addition: {
      header: 'תוספות כלליות',
      fields: {
        stops: {
          included: 'תחנות כלולות',
          pricePerAddition: {
            value: 'לכל תחנה נוספת',
            type: {
              fixed: 'קבוע',
              percentage: 'אחוזים (מהבסיס)',
            },
          },
        },
        seats: {
          included: 'מושבים כלולים',
          pricePerAddition: {
            value: 'לכל מושב נוסף',
            type: {
              fixed: 'קבוע',
              percentage: 'אחוזים (מהבסיס)',
            },
          },
        },
      },
    },
    peakHoursSurcharge: {
      header: 'תוספת עבור שעות שיא',
      fields: {
        name: 'שם',
        fromTime: 'מ-',
        toTime: 'עד',
        priceAddition: {
          value: 'תוספת מחיר',
          type: {
            fixed: 'קבוע',
            percentage: 'אחוזים (מהבסיס)',
          },
        },
        weekDays: 'ימי חול',
      },
      addBtn: 'הוסף תוספת עבור שעות שיא',
    },

    geoAdditions: {
      generalAreaEntrance: {
        header: 'כניסה כללית לאזור',
        fields: {
          pricePerArea: 'מחיר לכל אזור',
          chargingMethod: {
            name: 'שיטת חיוב',
            options: {
              drivingThrough: 'מעבר דרך האזור',
              stops: 'עצירות',
            },
          },
          type: {
            fixed: 'קבוע',
            percentage: 'אחוזים (מהבסיס)',
          },
        },
      },
      specificAreaEntrance: {
        header: 'כניסה לאזור מסוים',
        fields: {
          areasIds: 'אזור',
          pricePerArea: 'מחיר לכל אזור',
          chargingMethod: {
            name: 'שיטת חיוב',
            options: {
              drivingThrough: 'מעבר דרך האזור',
              stops: 'עצירות',
            },
          },
          type: {
            fixed: 'קבוע',
            percentage: 'אחוזים (מהבסיס)',
          },
        },
        addBtn: 'הוסף אזור',
      },
    },
  },
};

export default rates;
